import { defineMessages } from "react-intl";

export const messages = defineMessages({
  noData: {
    id: "ari.management.noData",
    defaultMessage: "There is no data"
  }
});